export const SET = 'SET'
export const REMOVE = 'REMOVE'
export type SetFlag = (payload: { type: string, name: string, value: boolean }) => void
